export const ROUTES = {
  home: "/",
  import: "/teamm/:id",
  live: "/live",
  search: "/search",
  searchSchedule: "/search/:id/schedule",
  searchPlayers: "/search/players",
  teams: {
    list: "/teams",
    team: "/teams/:id",
    publicFollow: "/search/:publicID/public/follow", //public id
    privateFollow: "/search/:id/private/follow", //non-public id
    unfollow: "/search/:id/unfollow", //non-public id
    schedule: "/teams/:id/schedule",
    summaries: "/teams/:id/game-summaries",
    live: "/teams/:id/live",
    player: "/teams/:id/players/:pid",
    players: "/teams/:id/players",
    users: "/teams/:id/users",
    playerStats: "/teams/:id/players/:pid/player-stats",
    assets: "/teams/:id/assets",
    stats: "/teams/:id/season-stats",
    sprayChart: "/teams/:id/spray-charts",
    pitchSmart: "/teams/:id/pitch-smart",
    opponents: "/teams/:id/opponents",
    avatar: "/teams/:id/avatar",
    events: {
      event: "/teams/:id/schedule/:eid",
      summary: "/teams/:id/game-summaries/:eid",
      schedule: "/teams/:id/schedule",
      scheduleEvent: "/teams/:id/schedule/:eid",
      plays: "/teams/:id/schedule/:eid/plays",
      startingLineup: "/teams/:id/schedule/:eid/starting-lineup",
      liveStream: "/teams/:id/schedule/:eid/live",
      playerStats: "/teams/:id/schedule/events/:eid/player-stats",
      opponents: "/teams/:id/schedule/events/:eid/opponents",
      boxScore: "/teams/:id/schedule/:eid/box-score",
      videos: "/teams/:id/schedule/:eid/videos",
      playlist: "/teams/:id/schedule/:eid/videos/:vid/playlist.m3u8",
      clip: "/teams/:id/schedule/:eid/videos/:vid/:clipID",
      videoStream: "/teams/:id/schedule/:eid/video-stream",
      videoStreamPlaylist: "/teams/:id/schedule/:eid/video-stream/playlist.m3u8",
      gameStream: "/teams/:id/schedule/:eid/game-stream",
      opponentGameStream: "/teams/:id/schedule/:eid/opponent-game-stream",
      opponentSeasonStats: "/teams/:id/schedule/:eid/opponent-season-stats",
    },
  },
} as const;
